export default __webpack_public_path__ + "static/media/AddSub-FolderSmall.775b5dbb.svg";